import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root',
})
export class PublicService {
  // The email endpoints live on the package service: go through the same
  // helper as every other package call, so the URL is the build's own
  // environment.packageUrl (a hard-coded dev host sent prod traffic to dev).
  private generic = inject(GenericService);

  contactUs(data: any): Observable<any> {
    return this.generic.postPackage<any>('email/contact-us', data);
  }

  feedback(data: any): Observable<any> {
    return this.generic.postPackage<any>('email/feedback', data);
  }
}
